import { angularEvents } from "../../../../bridge/angularEvents";
import { reactEvents } from "../../../../bridge/reactEvents";

// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('product.productimport',{
        url: '/productimport?type',
        views: {'wideColumnView@product': {
            templateUrl: 'main/product/productimport/productimport.tpl.html',
            controller: 'ProductImportController as vm'
        }},
        resolve: {
            suppliers: suppliersResolver,
            locations: locationsResolver,
            articleCollections: articleCollectionsResolver,
            orderCollections: orderCollectionsResolver,
            importType: importTypeResolver
        }
    });
}

// @ngInject
function suppliersResolver(FileDataImportApiServiceV2) {
    return FileDataImportApiServiceV2.getSuppliers();
}

// @ngInject
function locationsResolver(FileDataImportApiServiceV2) {
    return FileDataImportApiServiceV2.getLocations();
}
// @ngInject
function articleCollectionsResolver(FileDataImportApiServiceV2) {
    return FileDataImportApiServiceV2.getArticleCollections();
}
// @ngInject
function orderCollectionsResolver(FileDataImportApiServiceV2) {
    return FileDataImportApiServiceV2.getOrderCollections();
}
// @ngInject
function importTypeResolver($stateParams) {
    return $stateParams.type ? $stateParams.type : 'newImportFile';
}

// @ngInject
function ProductImportController($state, $scope, importType, $translate, loadSpinnerService, ToasterService, confirmationDialogService,
    FileDataImportApiServiceV2, suppliers, locations, articleCollections, orderCollections, $sce) {
    var vm = this;
    var hasOwnProperty = Object.prototype.hasOwnProperty;

    //Properties
    vm.importType = importType;
    vm.importFileType = 'productImport';
    vm.importSku = false;
    vm.usePricesFromExistingProducts = {
       forPurchaseCost : false,
       forSalesPrice : false,
       forPreviousPrice : false
    };
    vm.importFile = {};
    vm.JSonAdaptedSheetData = undefined;
    vm.importFileColumnNames =[];
    vm.importMapping = {
        column: {}
    };
    vm.productImportRequest = {
        articleCollection: undefined,
        fileName: '',
        importRows: [],
        importType: '',
        location: undefined,
        orderCollection: undefined,
        plannedDeliveryDate: new Date(),
        supplier: undefined
    };
    vm.suppliers = suppliers;

    vm.temp = {
        id: 123,
        companyName: "TEST",
        oldDate: Date.now,
        newDate: Date.now,
        ordersAmount: 1,
        productsAmount: 2,
        variantsAmount: 3
    };

    vm.locations = locations;
    vm.articleCollections = articleCollections;
    vm.orderCollections = orderCollections;
    vm.errorList = [];
    vm.assumptionList = [];
    vm.readyForSave = false;
    vm.readyForImport = false;
    vm.useMainGroupAndBrand = false;
    vm.isAllowedToImportSku = false;

    //Methods
    vm.handleImportFile = handleImportFile;
    vm.saveSupplierMapping = saveSupplierMapping;
    vm.validateImportFile = validateImportFile;
    vm.goToEditor = goToEditor;
    vm.mandatoryAccordionAvailable = mandatoryAccordionAvailable;
    vm.mappingsAccordionAvailable = mappingsAccordionAvailable;
    vm.confirmGoToEditor = confirmGoToEditor;
    vm.changeToImportNewFileView = changeToImportNewFileView;
    vm.changeToUseExistingFileView = changeToUseExistingFileView;
    vm.changeToUseExternalFileView = changeToUseExternalFileView;
    vm.isPurchasingCurrencyCodePopulated = isPurchasingCurrencyCodePopulated;
    vm.getPricesFromProductWarningMessage = getPricesFromProductWarningMessage;


    var unsubGoToEditorEvent = reactEvents.goToImportEditorById.subscribe((importId) => {
        console.log("Recieved:" + importId);
        $state.go('product.productimporteditor', { importFileId: importId }).then(function(response) {
        }, function(error) {
                ToasterService.showError(error.message);
        });
    });

    var unsubExternalImportsExistEvent = reactEvents.externalImportsExist.subscribe(() => {
        changeToUseExternalFileView();
        $scope.$digest();
    });

    $scope.$on('$destroy', () => {
        unsubGoToEditorEvent();
        unsubExternalImportsExistEvent();
    });

    activate();


    function activate() {
        var currentDate = new Date();
        angularEvents.productImportViewLoaded.dispatch();
        vm.articleCollections = _.filter(vm.articleCollections, function(coll) {
            var fromDate = new Date(coll.fromDate);
            var toDate = new Date(coll.toDate);
            return fromDate >= currentDate ||
                (fromDate <= currentDate && toDate >= currentDate);
        });
        vm.orderCollections = _.filter(vm.orderCollections, function(coll) {
            var fromDate = new Date(coll.fromDate);
            var toDate = new Date(coll.toDate);
            return fromDate >= currentDate ||
                (fromDate <= currentDate && toDate >= currentDate);
        });

        $scope.$watch(function() { return vm.importFileType;}, function(oldValue, newValue) {
            if (oldValue !== newValue) {
                vm.readyForSave = false;
                vm.readyForImport = false;
            }
        });
        $scope.$watch(function() { return (vm.productImportRequest.supplier) ? vm.productImportRequest.supplier.id : undefined; }, function(newValue, oldValue) {
            if (newValue === undefined) { vm.productImportRequest.supplier = undefined; return; }
            if (newValue !== oldValue) {
                loadSpinnerService.start('mainSpinner');
                vm.productImportRequest.supplier.id = vm.productImportRequest.supplier.id;
                FileDataImportApiServiceV2.getColumnMapping(vm.productImportRequest.supplier.id).then(function(response) {
                    if (response && response.id !== 0) {
                        //Retrieve saved mapping, has a column name eg. "alternativeArticleNumber" and the name of the column in the file eg. "Modell"
                        var keys = Object.keys(response);
                        var filteredKeys = _.filter(keys, function(key) { return key !== 'id'; }); //Removes id column
                        var dbColumnNames = [];
                        _.forEach(filteredKeys, function(key) {
                            if (response[key] && response[key].trim().length > 0) {
                                if (!_.find(dbColumnNames, function(col) { return col.column === key; })) {
                                    var nameStr = normalizeString(response[key]);
                                    var newColumn = { column: key, name: nameStr };
                                    dbColumnNames.push(newColumn);
                                }
                            }
                        });

                        //Mappings in the file has already been read into vm.importFileColumnNames
                        //Match mapping in db against mappings in vm.importFileColumnNames so to only update those that HAVE a mapping, and only map where it isn't empty
                        var matchedColumns = [];
                        _.forEach(vm.importFileColumnNames, function(fileCol) {
                            var dbColumns = _.filter(dbColumnNames, function (dbCol) { if (dbCol.name.trim().length > 0 && dbCol.name.trim() === fileCol.name.trim()) { return dbCol; }});
                            if (dbColumns.length > 0) {
                                _.forEach(dbColumns, function(dbc) {
                                    matchedColumns.push(dbc);
                                });
                            }
                        });

                        //Compare matched columns with vm.importMapping which is used be the dropdowns
                        _.forEach(matchedColumns, function (matchedCol) {
                            var fileColumn = _.find(vm.importFileColumnNames, function(fileCol) { if (fileCol.name.trim() === matchedCol.name.trim()) { return fileCol; }});
                            if (fileColumn) {
                                vm.importMapping.column[matchedCol.column] = fileColumn;
                            }
                        });
                    }
                }, function (error) {
                    console.log(error);
                    ToasterService.showError($translate.instant('productimport.errorWhileReadingColumnMapping'), $translate.instant('common.error'));
                }).finally(function () {
                    loadSpinnerService.stop('mainSpinner');
                });

                vm.readyForSave = false;
                vm.readyForImport = false;

                //Remove error from list if user has chosen value
                vm.errorList = _.remove(vm.errorList, function(err) {
                    return err.code !== 'supplier';
                });
            }
        });
        $scope.$watch(function() { return (vm.importMapping.column.companyCode) ? vm.importMapping.column.companyCode : undefined; }, function(newValue, oldValue) {
            vm.errorList = _.remove(vm.errorList, function(err) {
                return err.code !== 'supplier';
            });
        });

        //Remove error from list if user has chosen value
        $scope.$watch(function() { return (vm.productImportRequest.location) ? vm.productImportRequest.location.id : undefined; }, function(newValue, oldValue) {
            if (vm.importFileType === 'orderImport') {
                vm.errorList = _.remove(vm.errorList, function(err) {
                    return err.code !== 'location';
                });
            }
        });
        $scope.$watch(function() { return (vm.importMapping.column.locationCode) ? vm.importMapping.column.locationCode : undefined; }, function(newValue, oldValue) {
            if (vm.importFileType === 'orderImport') {
                vm.errorList = _.remove(vm.errorList, function(err) {
                    return err.code !== 'location';
                });
            }
        });


        $scope.$watch(function() { return (vm.productImportRequest.articleCollection) ? vm.productImportRequest.articleCollection.id : undefined; }, function(newValue, oldValue) {
            vm.errorList = _.remove(vm.errorList, function(err) {
                return err.code !== 'articleCollection';
            });
        });
        $scope.$watch(function() { return (vm.importMapping.column.articleCollectionCode) ? vm.importMapping.column.articleCollectionCode : undefined; }, function(newValue, oldValue) {
            vm.errorList = _.remove(vm.errorList, function(err) {
                return err.code !== 'articleCollection';
            });
        });

        $scope.$watch(function() { return (vm.productImportRequest.orderCollection) ? vm.productImportRequest.orderCollection.id : undefined; }, function(newValue, oldValue) {
            if (vm.importFileType === 'orderImport') {
                vm.errorList = _.remove(vm.errorList, function(err) {
                    return err.code !== 'orderCollection';
                });
            }
        });
        $scope.$watch(function() { return (vm.importMapping.column.orderCollectionCode) ? vm.importMapping.column.orderCollectionCode : undefined; }, function(newValue, oldValue) {
            if (vm.importFileType === 'orderImport') {
                vm.errorList = _.remove(vm.errorList, function(err) {
                    return err.code !== 'orderCollection';
                });
            }
        });

        $scope.$watch(function() { return (vm.importMapping.column.plannedDeliveryDate) ? vm.importMapping.column.plannedDeliveryDate : undefined; }, function(newValue, oldValue) {
            if (vm.importFileType === 'orderImport') {
                vm.errorList = _.remove(vm.errorList, function(err) {
                    return err.code !== 'plannedDeliveryDate';
                });
            }
        });

        $scope.$watch(function() { return (vm.importMapping.column.alternativeArticleNumber) ? vm.importMapping.column.alternativeArticleNumber : undefined; }, function(newValue, oldValue) {
            if (vm.importFileType === 'orderImport') {
                vm.errorList = _.remove(vm.errorList, function(err) {
                    return err.code !== 'importMappingAlternativeArticleNumber';
                });
            }
        });
        $scope.$watch(function() { return (vm.importMapping.column.purchaseCost) ? vm.importMapping.column.purchaseCost : undefined; }, function(newValue, oldValue) {
            if (vm.importFileType === 'orderImport') {
                vm.errorList = _.remove(vm.errorList, function(err) {
                    return err.code !== 'importMappingPurchaseCost';
                });
            }
        });
        $scope.$watch(function() { return (vm.importMapping.column.salesPrice) ? vm.importMapping.column.salesPrice : undefined; }, function(newValue, oldValue) {
            if (vm.importFileType === 'orderImport') {
                vm.errorList = _.remove(vm.errorList, function(err) {
                    return err.code !== 'importMappingSalesPrice';
                });
            }
        });
        $scope.$watch(function() { return (vm.importMapping.column.salesPrice) ? vm.importMapping.column.salesPrice : undefined; }, function(newValue, oldValue) {
            if (vm.importFileType === 'orderImport') {
                vm.errorList = _.remove(vm.errorList, function(err) {
                    return err.code !== 'importMappingSalesPrice';
                });
            }
        });
        $scope.$watch(function() { return (vm.importMapping.column.barcode) ? vm.importMapping.column.barcode : undefined; }, function(newValue, oldValue) {
            if (vm.importFileType === 'orderImport') {
                vm.errorList = _.remove(vm.errorList, function(err) {
                    return err.code !== 'assumptionBarcode';
                });
            }
        });

        FileDataImportApiServiceV2.getTenantConfig().then(function(response) {
            vm.isAllowedToImportSku = response.data.isAllowedToImportSku;
        });
    }

    function validateDocumentRowCount() {
        const rowCountTolerance = 10000;

        if(getImportFileRowCount() > rowCountTolerance) {
            ToasterService.showError($translate.instant("productimport.fileExceedsRowLimitWarning").replace('%1', rowCountTolerance.toString()));
        }
    }

    function getImportFileRowCount() {
        if (!vm.JSonAdaptedSheetData || vm.JSonAdaptedSheetData.length === 0) {
            return 0;
        }
        console.debug(vm.JSonAdaptedSheetData.length);
        return vm.JSonAdaptedSheetData.length;
    }

    function getPricesFromProductWarningMessage() {
        var foo = $translate.instant("productimport.pricesfromproductwarningmessage");
        return $sce.trustAsHtml(foo);
    }

    function mandatoryAccordionAvailable() {
        return vm.importType === 'newImportFile' &&
            vm.JSonAdaptedSheetData &&
            vm.JSonAdaptedSheetData.length > 0 &&
            vm.importFileColumnNames &&
            vm.importFileColumnNames.length > 0;
    }

    function mappingsAccordionAvailable() {
        return vm.importType === 'newImportFile' &&
                vm.JSonAdaptedSheetData &&
                vm.JSonAdaptedSheetData.length > 0 &&
                vm.importFileColumnNames &&
                vm.importFileColumnNames.length > 0 &&
                (vm.productImportRequest.supplier || vm.importMapping.column.companyCode) &&
                (vm.productImportRequest.articleCollection || vm.importMapping.column.articleCollectionCode) &&
                (
                    vm.importFileType === 'productImport' ||
                    (vm.importFileType === 'orderImport' &&
                        (vm.productImportRequest.location || vm.importMapping.column.locationCode) &&
                        (vm.productImportRequest.orderCollection || vm.importMapping.column.orderCollectionCode)
                    )
                );
    }

    function handleImportFile(file, revalidate) {
        var reader = new FileReader();
        vm.productImportRequest.fileName = file.name;
        reader.onload = onLoadFunction;
        loadSpinnerService.start('mainSpinner');
        reader.readAsArrayBuffer(file);

        function onLoadFunction(e) {
            try {
                // --- File data read ---
                // From MDN: "readAsBinaryString is deprecated and readAsArrayBuffer() should be used instead."

                // ReadAsArrayBuffer solution.
                var data = "";
                var bytes = new Uint8Array(e.target.result);
                var length = bytes.byteLength;
                for (var i = 0; i < length; i++) {
                    data += String.fromCharCode(bytes[i]);
                }

                // --- XLSX ---
                // Read Excel data into a workbook object representation.
                var workbook = XLSX.read(data, {type: 'binary'});

                // Getting the name of the first sheet in the workbook.
                var firstSheetName = workbook.SheetNames[0];

                // Getting the sheet based on the firstSheetName.
                var workSheet = workbook.Sheets[firstSheetName];

                // The JSon representation of the worksheet returned by js-xlsx is pretty similar to how
                // we want our request data to be formatted.
                vm.JSonAdaptedSheetData = XLSX.utils.sheet_to_json(workSheet);

                cleanColumnNames();

                extractImportFileColumnNames();

                validateDocumentRowCount();

                vm.errorList = [];
                if (revalidate) {
                    validateImportFile();
                }
            } catch (error) {
                console.log(error);
                ToasterService.showError($translate.instant('productimport.errorWhileReadingImportFile'), $translate.instant('common.error'));
            } finally {
                loadSpinnerService.stop('mainSpinner');
            }
        }
    }

    function cleanColumnNames() {
        if (vm.JSonAdaptedSheetData.length !== 0) {
            for (var sheetIndex = 0; sheetIndex < vm.JSonAdaptedSheetData.length; sheetIndex++) {
                var sheetData = vm.JSonAdaptedSheetData[sheetIndex];
                var keys = Object.keys(sheetData);

                for (var keyIndex = 0; keyIndex < keys.length; keyIndex++) {
                    var key = keys[keyIndex];
                    var origKey = key;
                    var keyStr = normalizeString(key);
                    //Check if the key has changed after normalization, if yes replace the kolumn with the new name
                    if (origKey !== keyStr) {
                        sheetData[keyStr] = sheetData[origKey];
                        var index = keys.indexOf(origKey);
                        keys[index] = keyStr;
                        sheetData = _.pick(sheetData, keys);
                    }
                }

                vm.JSonAdaptedSheetData[sheetIndex] = sheetData;
            }
        }
    }

    // js-xlsx has done most of the work already. All we need to do is extract the javascript object property names
    function extractImportFileColumnNames() {
        if (vm.JSonAdaptedSheetData.length !== 0) {
            vm.importFileColumnNames = [];
            _.forEach(vm.JSonAdaptedSheetData, function(sheetData) {
                var keys = Object.keys(sheetData);

                _.forEach(keys, function(key) {
                    if (!_.find(vm.importFileColumnNames, function(col) { return col.name === key; })) {
                        var nameStr = normalizeString(key);
                        if (!_.find(vm.importFileColumnNames, function(col) { return col.name === nameStr; })) {
                            var newColumn = { id: vm.importFileColumnNames.length, name: nameStr };
                            vm.importFileColumnNames.push(newColumn);
                        }
                    }
                });
            });
        }
    }

    function normalizeString(str) {
        //Make sure string contains only letters, numbers and some special characters
        var retVal = str;
        var r = /[^ ()/\\0-9\u0041-\u005A\u0061-\u007A\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u0527\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0\u08A2-\u08AC\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0977\u0979-\u097F\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C33\u0C35-\u0C39\u0C3D\u0C58\u0C59\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D60\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191C\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19C1-\u19C7\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FCC\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA697\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA78E\uA790-\uA793\uA7A0-\uA7AA\uA7F8-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA80-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uABC0-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]+/g;
        retVal = str.replace(r, '');
        //Make sure there are no extra whitespace
        var r2 = /[\s]{2,}/g;
        retVal = retVal.replace(r2, ' ');
        //Remove leading and trailing whitespace
        retVal = retVal.trim();
        return retVal;
    }

    function saveSupplierMapping() {
        if (!vm.productImportRequest || !vm.productImportRequest.supplier || !vm.productImportRequest.supplier.id) { return; }

        //Make sure strings are clean
        _.forEach(vm.importMapping.column, function(mapCol) {
            mapCol.name = normalizeString(mapCol.name);
        });

        //Save mapping
        var mappingRequest = {
            alternativeArticleNumber: vm.importMapping.column.alternativeArticleNumber  ? vm.importMapping.column.alternativeArticleNumber.name : '',
            articleCollectionCode: vm.importMapping.column.articleCollectionCode        ? vm.importMapping.column.articleCollectionCode.name : '',
            articleDescription: vm.importMapping.column.articleDescription              ? vm.importMapping.column.articleDescription.name : '',
            articleName: vm.importMapping.column.articleName                            ? vm.importMapping.column.articleName.name : '',
            articleTypeName: vm.importMapping.column.articleTypeName                    ? vm.importMapping.column.articleTypeName.name : '',
            barcode: vm.importMapping.column.barcode                                    ? vm.importMapping.column.barcode.name : '',
            externalSku: vm.importMapping.column.externalSku                            ? vm.importMapping.column.externalSku.name : '',
            supplierSku: vm.importMapping.column.supplierSku                            ? vm.importMapping.column.supplierSku.name : '',
            departmentCode: vm.importMapping.column.departmentCode                      ? vm.importMapping.column.departmentCode.name : '',
            intrastatCode: vm.importMapping.column.intrastatCode                        ? vm.importMapping.column.intrastatCode.name : '',
            itemGroupCode: vm.importMapping.column.itemGroupCode                        ? vm.importMapping.column.itemGroupCode.name : '',
            locationCode: vm.importMapping.column.locationCode                          ? vm.importMapping.column.locationCode.name : '',
            orderCollectionCode: vm.importMapping.column.orderCollectionCode            ? vm.importMapping.column.orderCollectionCode.name : '',
            orderNumberExternal: vm.importMapping.column.orderNumberExternal            ? vm.importMapping.column.orderNumberExternal.name : '',
            plannedDeliveryDate: vm.importMapping.column.plannedDeliveryDate            ? vm.importMapping.column.plannedDeliveryDate.name : '',
            previousPrice: vm.importMapping.column.previousPrice                        ? vm.importMapping.column.previousPrice.name : '',
            purchaseCost: vm.importMapping.column.purchaseCost                          ? vm.importMapping.column.purchaseCost.name : '',
            quantity: vm.importMapping.column.quantity                                  ? vm.importMapping.column.quantity.name : '',
            salesPrice: vm.importMapping.column.salesPrice                              ? vm.importMapping.column.salesPrice.name : '',
            subCategory: vm.importMapping.column.subCategory                            ? vm.importMapping.column.subCategory.name : '',
            companyCode: vm.importMapping.column.supplier                               ? vm.importMapping.column.supplier.name : '',
            variant1Name: vm.importMapping.column.variant1Name                          ? vm.importMapping.column.variant1Name.name : '',
            variant2Name: vm.importMapping.column.variant2Name                          ? vm.importMapping.column.variant2Name.name : '',
            length: vm.importMapping.column.length                                      ? vm.importMapping.column.length.name : '',
            height: vm.importMapping.column.height                                      ? vm.importMapping.column.height.name : '',
            width: vm.importMapping.column.width                                        ? vm.importMapping.column.width.name : '',
            weight: vm.importMapping.column.weight                                      ? vm.importMapping.column.weight.name : '',
            countryCode: vm.importMapping.column.countryCode                            ? vm.importMapping.column.countryCode.name : ''
        };

        loadSpinnerService.start('mainSpinner');
        FileDataImportApiServiceV2.saveColumnMapping(vm.productImportRequest.supplier.id, mappingRequest).then(function(response) {
            ToasterService.showSuccess($translate.instant('productimport.mappingSaved'), $translate.instant('productimport.productImport'));
        }, function (error) {
            console.log(error);
            ToasterService.showError($translate.instant('productimport.errorWhileSavingMapping'), $translate.instant('common.error'));
        }).finally(function () {
            loadSpinnerService.stop('mainSpinner');
        });
    }

    function validateImportFile() {
        var result = false;
        result = validateMandatoryFields(true);
        vm.readyForSave = result;
        var columnsToCheckForEmptyFields = [
            'barcode',
            vm.usePricesFromExistingProducts.forPreviousPrice ? 'ignore' : 'previousPrice',
            vm.usePricesFromExistingProducts.forPurchaseCost ? 'ignore' : 'purchaseCost',
            vm.usePricesFromExistingProducts.forSalesPrice ? 'ignore' : 'salesPrice',
            'variant1Name',
            'variant2Name'
        ];
        var importMappingColumnsToCheck = [];
        _.forEach(columnsToCheckForEmptyFields, function(columnName) {
            if(columnName !== 'ignore') importMappingColumnsToCheck.push(vm.importMapping.column[columnName]);
        });

        _.forEach(vm.JSonAdaptedSheetData, function(sheetData) {
            _.forEach(importMappingColumnsToCheck, function(column) {
                if (column && column && column.name.trim().length > 0) {
                    if (!sheetData[column.name] || sheetData[column.name].length === 0) {
                        result = false;
                        var errorStr = $translate.instant('productimport.errorContainsEmptyFields').replace('%1', column.name);
                        addErrorList(column, errorStr, true);
                    }
                }
            });

            var errorStr = '';
            var findMultipleSeparatorsPattern = '[\\.\\,](?=[^\\.\\,]*[\\.\\,])';
            var findMultipleSeparatorsRegExp = new RegExp(findMultipleSeparatorsPattern,'g');
            var findLastCommaPattern = '[\\,](?![^\\,]*[\\,])';
            var findLastCommaRegExp = new RegExp(findLastCommaPattern,'g');
            var findNonDigitCharactersPattern = '[^0-9]';
            var findNonDigitCharactersRegExp = new RegExp(findNonDigitCharactersPattern,'g');
            var findFirstCommaAndAllNumbersBehindItPattern = '[\\.\\,][0-9]*[0-9]';
            var findFirstCommaAndAllNumbersBehindItRegExp = new RegExp(findFirstCommaAndAllNumbersBehindItPattern,'g');
            var purchaseCost = vm.importMapping.column.purchaseCost;
            if (purchaseCost && sheetData[purchaseCost.name]) {
                if (findMultipleSeparatorsRegExp.test(sheetData[purchaseCost.name])) {
                    sheetData[purchaseCost.name] = sheetData[purchaseCost.name].replace(findMultipleSeparatorsRegExp, '');
                    addAssumptionList('assumptionPurchaseCostMultipleSeparators', $translate.instant('productimport.assumptionPurchaseCostMultipleSeparators'));
                }
                if (findLastCommaRegExp.test(sheetData[purchaseCost.name])) {
                    sheetData[purchaseCost.name] = sheetData[purchaseCost.name].replace(findLastCommaRegExp, '.');
                }
                if (isNaN(Number(sheetData[purchaseCost.name]))) {
                    //Check if purchaseCost can be parsed to int/decimal
                    result = false;
                    errorStr = $translate.instant('productimport.errorPurchaseCostContainsInvalidNumber').replace('%1', purchaseCost.name);
                    addErrorList('purchaseCost', errorStr, true);
                }
            }
            var salesPrice = vm.importMapping.column.salesPrice;
            if (salesPrice && sheetData[salesPrice.name]) {
                if (findMultipleSeparatorsRegExp.test(sheetData[salesPrice.name])) {
                    sheetData[salesPrice.name] = sheetData[salesPrice.name].replace(findMultipleSeparatorsRegExp, '');
                    addAssumptionList('assumptionSalesPriceMultipleSeparators', $translate.instant('productimport.assumptionSalesPriceMultipleSeparators'));
                }
                if (findLastCommaRegExp.test(sheetData[salesPrice.name])) {
                    sheetData[salesPrice.name] = sheetData[salesPrice.name].replace(findLastCommaRegExp, '.');
                }
                if (isNaN(Number(sheetData[salesPrice.name]))) {
                    //Check if salesPrice can be parsed to int/decimal
                    result = false;
                    errorStr = $translate.instant('productimport.errorSalesPriceContainsInvalidNumber').replace('%1', salesPrice.name);
                    addErrorList('salesPrice', errorStr, true);
                }
            }
            var previousPrice = vm.importMapping.column.previousPrice;
            if (previousPrice && sheetData[previousPrice.name]) {
                if (findMultipleSeparatorsRegExp.test(sheetData[previousPrice.name])) {
                    sheetData[previousPrice.name] = sheetData[previousPrice.name].replace(findMultipleSeparatorsRegExp, '');
                    addAssumptionList('assumptionPreviousPriceMultipleSeparators', $translate.instant('productimport.assumptionPreviousPriceMultipleSeparators'));
                }
                if (findLastCommaRegExp.test(sheetData[previousPrice.name])) {
                    sheetData[previousPrice.name] = sheetData[previousPrice.name].replace(findLastCommaRegExp, '.');
                }
                if (isNaN(Number(sheetData[previousPrice.name]))) {
                    //Check if previousPrice can be parsed to int/decimal
                    result = false;
                    errorStr = $translate.instant('productimport.errorPreviousPriceContainsInvalidNumber').replace('%1', previousPrice.name);
                    addErrorList('previousPrice', errorStr, true);
                }
            }

            if(vm.importFileType === 'orderImport') {
                var quantity = vm.importMapping.column.quantity;
                if(quantity && sheetData[quantity.name]) {
                    if (findFirstCommaAndAllNumbersBehindItRegExp.test(sheetData[quantity.name])) {
                        sheetData[quantity.name] = sheetData[quantity.name].replace(findFirstCommaAndAllNumbersBehindItRegExp, '');
                        addAssumptionList('assumptionQuantityMultipleSeparators', $translate.instant('productimport.assumptionQuantityMultipleSeparators'));
                    }
                    if (findLastCommaRegExp.test(sheetData[quantity.name])) {
                        sheetData[quantity.name] = sheetData[quantity.name].replace(findLastCommaRegExp, '.');
                    }
                    if (isNaN(Number(sheetData[quantity.name]))) {
                        //Check if quantity can be parsed to int/decimal
                        result = false;
                        errorStr = $translate.instant('productimport.errorPreviousPriceContainsInvalidNumber').replace('%1', quantity.name);
                        addErrorList('quantity', errorStr, true);
                    }
                }
            }

            var intrastatCode = vm.importMapping.column.intrastatCode;
            if (intrastatCode && sheetData[intrastatCode.name]) {
                if (findNonDigitCharactersRegExp.test(sheetData[intrastatCode.name])) {
                    sheetData[intrastatCode.name] = sheetData[intrastatCode.name].replace(findNonDigitCharactersRegExp, '');
                }
                if (sheetData[intrastatCode.name].length === 8) {
                    //Check if intrastatCode has correct length (8 digits will be filled out with zeros)
                    sheetData[intrastatCode.name] = sheetData[intrastatCode.name] + '00';
                }
                if (sheetData[intrastatCode.name].length !== 10) {
                    //Check if intrastatCode has correct length (10 digits)
                    result = false;
                    errorStr = $translate.instant('productimport.errorIntrastatCodeHasIncorrectLength').replace('%1', intrastatCode.name);
                    addErrorList('intrastatCodeLength', errorStr, true);
                }
                if (isNaN(Number(sheetData[intrastatCode.name]))) {
                    //Check if intrastatCode can be parsed to int/decimal
                    result = false;
                    errorStr = $translate.instant('productimport.errorIntrastatContainsInvalidNumber').replace('%1', intrastatCode.name);
                    addErrorList('previousPrice', errorStr, true);
                }
            }
            var plannedDeliveryDate = vm.importMapping.column.plannedDeliveryDate;
            if (plannedDeliveryDate && sheetData[plannedDeliveryDate.name]) {
                //Check if plannedDeliveryDate can be parsed to datetime
                var dat = sheetData[plannedDeliveryDate.name];
                var canParseDate = true;
                if (Object.prototype.toString.call(dat) === "[object Date]") {
                    // it is a date
                    if (isNaN(dat.getTime())) {
                      // date is not valid
                      canParseDate = false;
                    } else {
                      // date is valid
                    }
                } else {
                    // not a date
                    canParseDate = false;
                }

                if (!canParseDate) {
                    result = false;
                    errorStr = $translate.instant('productimport.errorCannotParseDeliveryDate').replace('%1', plannedDeliveryDate.name);
                    addErrorList('plannedDeliveryDate', errorStr, true);
                }
            }
        });

        vm.readyForImport = result;

        return result;
    }

    function validateMandatoryFields(outputErrors) {
        var result = true;
        vm.errorList = [];
        //vm.assumptionList = [];

        if (!vm.JSonAdaptedSheetData || vm.JSonAdaptedSheetData.length === 0) {
            result = false;
            addErrorList('importFileList', $translate.instant('productimport.errorMustReadImportFile'), outputErrors);
            return result;
        }
        if (!vm.productImportRequest.supplier && (!vm.importMapping.column.companyCode || vm.importMapping.column.companyCode.name.trim().length === 0)) {
            result = false;
            addErrorList('supplier', $translate.instant('productimport.errorMustChooseSupplier'), outputErrors);
        }
        if (vm.importFileType === 'orderImport' &&
            !vm.productImportRequest.location && (!vm.importMapping.column.locationCode || vm.importMapping.column.locationCode.name.trim().length === 0)) {
            result = false;
            addErrorList('location', $translate.instant('productimport.errorMustChooseLocation'), outputErrors);
        }
        if (!vm.productImportRequest.articleCollection && (!vm.importMapping.column.articleCollectionCode || vm.importMapping.column.articleCollectionCode.name.trim().length === 0)) {
            result = false;
            addErrorList('articleCollection', $translate.instant('productimport.errorMustChooseSeason'), outputErrors);
        }
        if (vm.importFileType === 'orderImport' &&
            !vm.productImportRequest.orderCollection && (!vm.importMapping.column.orderCollectionCode || vm.importMapping.column.orderCollectionCode.name.trim().length === 0)) {
            result = false;
            addErrorList('orderCollection', $translate.instant('productimport.errorMustChooseSeason'), outputErrors);
        }
        if (vm.importFileType === 'orderImport' && !vm.productImportRequest.plannedDeliveryDate && (!vm.importMapping.column.plannedDeliveryDate || vm.importMapping.column.plannedDeliveryDate.name.trim().length === 0)) {
            result = false;
            addErrorList('plannedDeliveryDate', $translate.instant('productimport.errorMustChooseDeliveryDate'), outputErrors);
        }
        if (vm.importFileType === 'orderImport' && !vm.productImportRequest.quantity && (!vm.importMapping.column.quantity || vm.importMapping.column.quantity.name.trim().length === 0)) {
            result = false;
            addErrorList('quantity', $translate.instant('productimport.errorMustChooseQuantity'), outputErrors);
        }
        if (isEmpty(vm.importMapping) || isEmpty(vm.importMapping.column)) {
            result = false;
            addErrorList('importMapping', $translate.instant('productimport.errorMustChooseMapping'), outputErrors);
        } else {
            if (!vm.importMapping.column.alternativeArticleNumber || vm.importMapping.column.alternativeArticleNumber.name.trim().length === 0) {
                addAssumptionList('assumptionAlternativeArticleNumber', $translate.instant('productimport.assumptionDoNotUseAlternativeArticleNumber'));
            }
            if ((!vm.importMapping.column.purchaseCost || vm.importMapping.column.purchaseCost.name.trim().length === 0) && !vm.usePricesFromExistingProducts.forPurchaseCost) {
                result = false;
                addErrorList('importMappingPurchaseCost', $translate.instant('productimport.errorMustChoosePurchaseCost'), outputErrors);
            }
            if ((!vm.importMapping.column.salesPrice || vm.importMapping.column.salesPrice.name.trim().length === 0) && !vm.usePricesFromExistingProducts.forSalesPrice) {
                result = false;
                addErrorList('importMappingSalesPrice', $translate.instant('productimport.errorMustChooseSalesPrice'), outputErrors);
            }
            if (vm.importMapping.column.salesPrice && (!vm.importMapping.column.previousPrice || vm.importMapping.column.previousPrice.name.trim().length === 0) && !vm.usePricesFromExistingProducts.forPreviousPrice) {
                addAssumptionList('assumptionPreviousPrice', $translate.instant('productimport.assumptionPreviousPriceIsSalesPrice'));
            } else { vm.assumptionList = _.filter(vm.assumptionList, function(ass) { return ass.code !== 'assumptionPreviousPrice'; }); }
            if (!vm.importMapping.column.barcode || vm.importMapping.column.barcode.name.trim().length === 0) {
                addAssumptionList('assumptionBarcode', $translate.instant('productimport.assumptionBarcodeWillBeGenerated'));
            } else { vm.assumptionList = _.filter(vm.assumptionList, function(ass) { return ass.code !== 'assumptionBarcode'; }); }
        }

        return result;
    }

    function readyForImport() {
        return isEmpty(vm.importMapping) || isEmpty(vm.importMapping.column) || vm.errorList.length > 0;
    }

    function isEmpty(obj) {
        // null and undefined are "empty"
        if (obj == null) { return true; }

        // Assume if it has a length property with a non-zero value
        // that that property is correct.
        if (obj.length > 0) { return false; }
        if (obj.length === 0) { return true; }

        // If it isn't an object at this point
        // it is empty, but it can't be anything *but* empty
        // Is it empty?  Depends on your application.
        if (typeof obj !== "object") { return true; }

        // Otherwise, does it have any properties of its own?
        // Note that this doesn't handle
        // toString and valueOf enumeration bugs in IE < 9
        for (var key in obj) {
            if (hasOwnProperty.call(obj, key)) { return false; }
        }

        return true;
    }

    function addErrorList(code, message, outputErrors) {
        if (!outputErrors) { return; }
        if (!_.find(vm.errorList, function (error) { return error.code === code; })) {
            vm.errorList.push({ code: code, message: message });
        }
    }

    function addAssumptionList(code, message) {
        if (!_.find(vm.assumptionList, function (assumption) { return assumption.code === code; })) {
            vm.assumptionList.push({ code: code, message: message });
        }
    }

    function confirmGoToEditor() {
        //Validate
        if (!validateImportFile()) { return; }

        //Save mappings
        saveSupplierMapping();

        //Confirm assumptions
        if (vm.assumptionList.length > 0) {
            var assumptionMessage = $translate.instant('productimport.confirmAssumptions1') + '<br><br>';
            assumptionMessage += '<ul>';
            _.forEach(vm.assumptionList, function(assumption) {
                assumptionMessage += '<li>' + assumption.message + '</li>';
            });
            assumptionMessage += '</ul>';
            assumptionMessage += $translate.instant('productimport.confirmAssumptions2');
            confirmationDialogService.showDialog(assumptionMessage).then(function (result) {
                if (result === false) {
                    return;
                }

                goToEditor();
            });
        } else {
            goToEditor();
        }
    }

    function changeToImportNewFileView() {
        vm.importType = 'newImportFile';
        reloadURL();
    }

    function changeToUseExistingFileView() {
        vm.importType = 'existingImportFile';
        reloadURL();
    }

    function changeToUseExternalFileView() {
        vm.importType = 'externalImportFile';
        reloadURL();
    }

    function reloadURL() {
        $state.go('product.productimport',
            {
                type: vm.importType
            },
            {notify: false}
        );
    }

    function isPurchasingCurrencyCodePopulated() {
        return (
            vm.productImportRequest.supplier &&
            vm.productImportRequest.supplier.purchasingCurrency &&
            vm.productImportRequest.supplier.purchasingCurrency.code !== undefined &&
            vm.productImportRequest.supplier.purchasingCurrency.code !== null &&
            vm.productImportRequest.supplier.purchasingCurrency.code !== ''
        );
    }

    function goToEditor() {
        if (vm.importMapping.column.salesPrice && (!vm.importMapping.column.previousPrice || vm.importMapping.column.previousPrice.name.trim().length === 0)) {
            vm.importMapping.column.previousPrice = angular.copy(vm.importMapping.column.salesPrice);
        }

        //Collect product import rows
        vm.productImportRequest.importRows = [];
        vm.productImportRequest.importType = vm.importFileType;
        vm.productImportRequest.isImportingSku = vm.importSku;
        vm.productImportRequest.usePricesFromExistingProducts = vm.usePricesFromExistingProducts;
        vm.productImportRequest.useMainGroupAndBrand = vm.useMainGroupAndBrand;

        var mappingKeys = Object.keys(vm.importMapping.column);
        _.forEach(vm.JSonAdaptedSheetData, function(sheetData) {
            var requestRowDto = {
                alternativeArticleNumber: '',
                articleCollectionCode: '',
                articleDescription: '',
                articleName: '',
                articleTypeName: '',
                barcode: '',
                departmentCode: '',
                intrastatCode: '',
                itemGroupCode: '',
                mainGroupCode: '',
                brandCode: '',
                locationCode: '',
                orderCollectionCode: '',
                orderNumberExternal: '',
                plannedDeliveryDate: '',
                previousPrice: '',
                purchaseCost: '',
                quantity: '',
                salesPrice: '',
                subCategory: '',
                companyCode: '',
                variant1Name: '',
                variant2Name: ''
            };
            _.forEach(mappingKeys, function(mapKey) {
                var mapValue = vm.importMapping.column[mapKey];
                if (mapValue && mapValue !== '') {
                    requestRowDto[mapKey] = sheetData[mapValue.name];
                }
            });

            vm.productImportRequest.importRows.push(requestRowDto);
        });

        //Create file
        loadSpinnerService.start('mainSpinner', { message: $translate.instant('productimport.loadingCreatingImportEntry') });
        FileDataImportApiServiceV2.createProductImportEntry(vm.productImportRequest).then(function(response) {
            if (response && response.id !== 0) {
                $state.go('product.productimporteditor', { importFileId: response.id });
            }
        }, function (error) {
            console.log(error);
            ToasterService.showError($translate.instant('productimport.errorWhileCreatingProductImportEntry'), $translate.instant('common.error'));
        }).finally(function () {
            loadSpinnerService.stop('mainSpinner');
        });
    }
}

angular
    .module('product.productimport', [])
    .config(stateConfig)
    .controller('ProductImportController', ProductImportController);
